import React, { useEffect, useState } from "react";
import { DropdownButton, Nav, Navbar, Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import logo from '../../assets/images/logo-blue.png'

export default function NavBar(props) {
  const navigate = useNavigate();

  return (
    <>

      <header
        id="header"
        className="page-header d-flex align-items-center justify-content-between p-1 flex-wrap"
      >
        <div className="logo-col d-flex align-items-center p-1 ">
          <a href="https://deeptherapy.ai" className="logo-link d-flex align-items-center">
            <img
              src={logo}
              alt="DeepTherapy"
              width="36"
              height="36"
            />
            <span className="logo-text">DeepTherapy</span>
          </a>
        </div>
        <div className="mobile-toggel d-block d-md-none px-4" role="button" onClick={() => props.setShowmenu(!props.showmenu)}>
        <i className="fa fa-bars" aria-hidden="true"></i>
        </div>
        <div className="header-right d-flex align-items-center">
          {/* <div className="customer-post">MF</div> */}
          <Navbar brand="React-Bootstrap" className="drp-navbar-top">
            <Nav right="true"  className="drp-nav-top">
            <Link to='/login'>
              <div className="customer-post" style={{width:'35px',height:'35px'}}>DT</div>
              <div className="drp-navbar-name btn">
                Login
              </div>
              </Link>
            </Nav>
          </Navbar>

        </div>
      </header>
    </>
  );
}
